if (!customElements.get('klaviyo-form-trigger')) {
  customElements.define(
    'klaviyo-form-trigger',
    class KlaviyoFormTrigger extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.openForm);
      }

      openForm() {
        const formId = this.dataset.formId;
        if (!formId) return;

        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      }
    }
  );
}
